import Model, { attr, belongsTo } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type { SubscriptionType } from 'district-ui-client/domain/subscription-type'
import type School from 'district-ui-client/models/school'
import type StringTransform from 'district-ui-client/transforms/string'
import type DateTransform from 'district-ui-client/transforms/date'

export default class SchoolRollover extends Model {
  @attr<StringTransform>('string') declare status: string

  // Marked as private to avoid use outside the class. use subscriptionType getter below
  @attr<StringTransform>('string') declare private product: SubscriptionType

  @attr<DateTransform>('date') declare createdAt?: Date

  @attr<DateTransform>('date') declare updatedAt?: Date

  @belongsTo<School>('school', { async: false, inverse: 'schoolRollovers' })
  declare school: School

  get subscriptionType() {
    return this.product
  }

  [Type] = 'school-rollover' as const
}
